import { useFocusMode } from '../../../context/useFocusMode'
import { useToast } from '../../../context/useToast'
import { Button } from '../Button'

export const FocusModeCriticalToastStrip = () => {
  const focusMode = useFocusMode()
  const { toasts, dismissToast } = useToast()
  const criticalToasts = toasts.filter((toast) => toast.severity === 'critical')
  if (!focusMode.active || criticalToasts.length === 0) return null

  return (
    <div className="grid gap-2" data-focus-mode-notification-slot>
      {criticalToasts.map((toast) => (
        <div key={toast.id} className="flex items-center gap-3 rounded-xl border border-[color-mix(in_srgb,var(--warning)_40%,transparent)] bg-[color-mix(in_srgb,var(--warning)_12%,transparent)] px-3 py-2 text-sm text-[var(--text-strong)]">
          <span className="min-w-0 flex-1">{toast.message}</span>
          {toast.action ? (
            <Button
              variant="link"
              size="sm"
              className="shrink-0"
              onClick={() => {
                focusMode.exit()
                toast.action?.run()
                dismissToast(toast.id)
              }}
            >
              View →
            </Button>
          ) : null}
        </div>
      ))}
    </div>
  )
}
